const CustomizedDot = ({cx, cy, stroke, payload, value, years, active, colour}) => {

  const yearLabel = String(payload.year).slice(-2);

    return (
      <svg x={cx - 10} y={cy - 10} width={30} height={30}>
        <circle cx={10} cy={10} r={active ? '10' : '8'} fill={'white'}
          stroke={stroke}
          strokeWidth={active ? '2' : '1'}
          />
        <text x={10} y={active ? '15' : '14'} textAnchor="middle" fill="#000" fontSize="10">{yearLabel}</text>
      </svg>
      );
};

export default CustomizedDot;
